import app from 'flarum/common/app';

app.initializers.add('indigo/flarum-ext-auth0-saw', () => {
  console.log('[indigo/flarum-ext-auth0-saw] Hello, forum and admin!');
});
